import { useApiQuery } from '../useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { appointmentFormEndpoints } from '@/lib/api/endpoints';
import { formSubmissionKeys } from '@/lib/queryKeys';
import type { FormSubmission } from '@/types/appointmentForm';

export function useAppointmentFormSubmissions(appointmentId: string | undefined) {
  return useApiQuery<FormSubmission[]>({
    queryKey: formSubmissionKeys.byAppointment(appointmentId ?? ''),
    queryFn: () =>
      apiGet<FormSubmission[]>(
        operationsClient,
        appointmentFormEndpoints.submissionsForAppointment(appointmentId as string),
      ),
    enabled: Boolean(appointmentId),
    showErrorToast: false,
  });
}
